import toSafeInteger from "lodash/toSafeInteger";
import { Batch } from "@wingspanhq/wingspan-api-sdk";

import { FLATFILE_REJECTED_ROWS_COUNT_METADATA_KEY } from "../constants";

/**
 * Rows the Flatfile listener could not upload into the batch. They never become
 * batch items, so they will never be imported.
 */
export const selectorImportBatchRejectedRowsCount = (batch?: Batch): number =>
  Math.max(
    toSafeInteger(batch?.metadata?.[FLATFILE_REJECTED_ROWS_COUNT_METADATA_KEY]),
    0
  );
